import { Fragment, useEffect, useState } from "react";
import { useListUser } from "stores/hooks/list-user";
import Line from "components/layout/line";
import { useList } from "stores/hooks/list";
import { adminDoGetListEntities } from "services/admin/list-entity";
import { ListEntity } from "models/list-entity";
import SingleListEntityBlock from "./blocks/single-list-entity-block";
import MultiListEntityBlock from "./blocks/multi-list-entity-block";
import StatusBlock from "./blocks/status-block";
import TechBlock from "./blocks/tech-block";

const ListUserBaseTab = () => {
  const [listEntities, toggleListEntities] = useState<ListEntity[]>([]);
  const listUser = useListUser();
  const list = useList();

  const update = async () => {
    if (list) {
      const listEntities = await adminDoGetListEntities(list);
      toggleListEntities(listEntities);
    }
  };

  useEffect(() => {
    update();
  }, [list?.uuid, listUser?.uuid]);

  if (!listUser || !list) {
    return null;
  }

  return (
    <Fragment>
      <Fragment>
        {listEntities.map((listEntity) => {
          return (
            <Fragment key={listEntity.uuid}>
              {!listEntity.multi && (
                <SingleListEntityBlock listEntity={listEntity} />
              )}
              {listEntity.multi && (
                <MultiListEntityBlock listEntity={listEntity} />
              )}
              <Line />
            </Fragment>
          );
        })}
      </Fragment>
      <TechBlock />
      <Line />
      <StatusBlock onUpdate={update} />
    </Fragment>
  );
};

export default ListUserBaseTab;
